import React from 'react';
import axios from 'axios';
import { Button, Header, Segment } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import SemesterInfo from './SemesterInfo';
import AddedSemesterInfo from './AddedSemesterInfo';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

class Semesters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            semester: '',
            semesters: [],
            numSemesterList: [],

            data: [],
            sPsemesterId: '',
            semesterId: '',
            sPsemester: {},

            optionalCoursesECTSMin: '',
            optionalCoursesECTSMax: '',
            optionalCoursesNumberMin: '',
            optionalCoursesNumberMax: '',

            created: false,
            allSemesterInfoCreated: false,
        };

        this.openSemester = this.openSemester.bind(this);
        this.updateSemesters = this.updateSemesters.bind(this);
        this.saveSemesterInfo = this.saveSemesterInfo.bind(this);
    }

    componentDidMount() {
        if (this.props.create) {
            if (this.props.success) {
                toast('Uspješno ste kreirali smjer (studijski program)!');
            }
        }
        let numSemesterList = [];
        for (let i = 1; i <= this.props.newSP.durationSemester; i += 1) {
            numSemesterList.push(i);
        }
        this.setState({ numSemesterList });
        this.openSemester();
    }

    updateSemesters(semester) {
        const sPsemester = this.state.semesters.find(el => el.studyProgramSemester.number === semester);

        const sPsemesterId = sPsemester.studyProgramSemester.id;
        const semesterOptlock = sPsemester.optLock;
        const semesterId = sPsemester.id;

        this.setState({
            sPsemester, semester, sPsemesterId, semesterOptlock, semesterId
        });
    }

    saveSemesterInfo() {
        this.setState({ semester: '' });
        this.openSemester();
    }

    openSemester() {
        axios.get(`study-programs/semesters/${this.props.newSP.id}`)
            .then(res => {
                const semesters = res.data;
                for (let i = 0; i < semesters.length; i += 1) {
                    if (semesters[i].optLock === 0) {
                        this.setState({ allSemesterInfoCreated: false });
                        break;
                    }
                    this.setState({ allSemesterInfoCreated: true });
                }
                this.setState({ semesters });
            })
            .catch(err => {
                console.log('Failed to fetch semesters');
            });
    }


    render() {
        const { numSemesterList } = this.state;
        return (
            <div>
                <Segment.Group raised>
                    <Segment>
                        <h3>Dodavanje osnovnih informacija o semestru</h3>
                    </Segment>
                    <Segment>
                        <Button basic='true' onClick={this.props.firstStep}>Preskoči dodavanje informacija o semestrima</Button>
                    </Segment>
                    <Segment>
                Odaberite semestar za koji želite dodati informacije<br /><br />
                        <Button.Group>
                            {numSemesterList.map((el, index) => (
                                <Button basic color={el === this.state.semester ? 'red' : 'blue'} onClick={() => { this.updateSemesters(el); }}>
                                    {el}. semestar
                                </Button>
                            ))}
                        </Button.Group>
                    </Segment>
                    {this.state.allSemesterInfoCreated && <Segment clearing>
                        <Button color="blue" floated="right" onClick={() => this.props.nextStep(7)}>
                      Dodavanje predmeta u semestre
                        </Button>
                    </Segment>}
                    <ToastContainer hideProgressBar />

                </Segment.Group>

                {this.state.semester && <Segment.Group raised>
                    <Segment>
                        <Header as="h3">{this.state.semester}. semestar
                        </Header>
                    </Segment>


                    {(this.state.semester && this.state.semesterOptlock === 0) ? <SemesterInfo
                        saveSemesterInfo={()=>{  toast('Uspješno ste unijeli informacije o semestru!'); this.saveSemesterInfo()}}
                        sPsemesterId={this.state.sPsemesterId}
                        semesterOptlock={this.state.semesterOptlock}
                        semesterId={this.state.semesterId}
                    />
                        : (this.state.semester && this.state.semesterOptlock !== 0) ?
                            <AddedSemesterInfo
                                sPsemester={this.state.sPsemester}
                                saveSemesterInfo={()=>{ toast('Uspješno ste izmijenili informacije o semestru!'); this.saveSemesterInfo()}}
                            />
                            : null}
                </Segment.Group>}
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}

export default Semesters;



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgramImplementation/Semesters.js